import { TagFragment, ResponsiveImage } from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const querySite = graphql(
  /* GraphQL */ `
    query SiteQuery($first: IntType = 100) {
      _site {
        globalSeo {
          siteName
          titleSuffix
        }
        favicon {
          url
        }
        faviconMetaTags {
          ...TagFragment
        }
      }
      allMenuCtas(first: $first) {
        id
        title
        reference {
          _modelApiKey
          slug
        }
        externalLink
        primary
      }
      allMenuItems(first: $first) {
        id
        children {
          id
          title
          description
          parent {
            id
          }
          reference {
            _modelApiKey
            slug
          }
          externalLink
        }
        externalLink
        parent {
          id
        }
        reference {
          __typename
          _modelApiKey
          slug
        }
        title
        description
        excludeFromMainMenu
      }
      allFooterMenuItems(first: $first) {
        id
        children {
          id
          title
          description
          parent {
            id
          }
          reference {
            _modelApiKey
            slug
          }
          externalLink
        }
        externalLink
        parent {
          id
        }
        reference {
          __typename
          _modelApiKey
          slug
        }
        title
        description
      }
      allFooterLinks {
        externalLink
        reference {
          _modelApiKey
          slug
        }
        title
      }
      allCategories {
        __typename
        _modelApiKey
        id
        name
        slug
      }
      allWorkCategories {
        __typename
        _modelApiKey
        id
        name
        slug
      }
      allReels {
        __typename
        _modelApiKey
        id
        title
        subtitle
        slug
        video {
          url
          mimeType
        }
        image {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 448 }
          ) {
            ...ResponsiveImage
          }
        }
      }
      allTeamMembers {
        __typename
        _modelApiKey
        id
        name
        media {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "4:3", w: 320 }
          ) {
            ...ResponsiveImage
          }
        }
        role
      }
      allGameCategories {
        __typename
        _modelApiKey
        id
        name
        slug
      }
    }
  `,
  [TagFragment, ResponsiveImage]
)
